import { inject } from '@angular/core';
import { CanActivateFn,Router } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  const routers=inject(Router)

  var loginuser = localStorage.getItem('loggedInUser');

  if (loginuser == null || loginuser == undefined) {
    routers.navigate(['home']);
    return false;
  }
  return true;
};
